export const bookIssueList = [
    {
      key: "1",
      id: "IB853629",
      dateofIssue: "20 Mar 2025",
      dueDate: "19 Aar 2025",
      issueTo: "Janet",
      class: "Year 3, Jupiter",
      booksIssued: "1",
      bookReturned: "0",
      img: "assets/img/students/student-01.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "2",
      id: "IB853628",
      dateofIssue: "24 Mar 2025",
      dueDate: "20 Aar 2025",
      issueTo: "Joann",
      class: "Year 4, Mars",
      booksIssued: "5",
      bookReturned: "3",
      img: "assets/img/students/student-02.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "3",
      id: "IB853627",
      dateofIssue: "02 Mar 2025",
      dueDate: "01 Apr 2025",
      issueTo: "Kathleen",
      "class ": "Year 3, Jupiter",
      booksIssued: "4",
      bookReturned: "2",
      img: "assets/img/students/student-03.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "4",
      id: "IB853626",
      dateofIssue: "16 Mar 2025",
      dueDate: "15 Apr 2025",
      issueTo: "Gifford",
      class: "Year 1, Mars",
      booksIssued: "3",
      bookReturned: "2",
      img: "assets/img/students/student-04.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "5",
      id: "IB853625",
      dateofIssue: "22 Mar 2025",
      dueDate: "20 Apr 2025",
      issueTo: "LisJupiter",
      class: "Year 2, Mars",
      booksIssued: "6",
      bookReturned: "4",
      img: "assets/img/students/student-05.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "6",
      id: "IB853624",
      dateofIssue: "10 Mar 2024",
      dueDate: "08 Apr 2025",
      issueTo: "Ralph",
      class: "Year 3, Mars",
      booksIssued: "4",
      bookReturned: "2",
      img: "assets/img/students/student-06.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "7",
      id: "IB853623",
      dateofIssue: "15 Mar 2024",
      dueDate: "14 Apr 2025",
      issueTo: "Julie",
      class: "Year 5, Jupiter",
      booksIssued: "5",
      bookReturned: "3",
      img: "assets/img/students/student-07.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "8",
      id: "IB853622",
      dateofIssue: "26 Mar 2024",
      dueDate: "25 Apr 2025",
      issueTo: "Ryan",
      class: "Year 6, Jupiter",
      booksIssued: "3",
      bookReturned: "1",
      img: "assets/img/students/student-08.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "9",
      id: "IB853621",
      dateofIssue: "06 Mar 2024",
      dueDate: "05 Apr 2025",
      issueTo: "Susan",
      class: "Year 8, Mars",
      booksIssued: "6",
      bookReturned: "4",
      img: "assets/img/students/student-09.jpg",
      issueRemarks: "Book Issued",
      
    },
    {
      key: "10",
      id: "IB853620",
      dateofIssue: "18 Mar 2024",
      dueDate: "16 Apr 2025",
      issueTo: "Richard",
      class: "Year 7, Mars",
      booksIssued: "2",
      bookReturned: "1",
      img: "assets/img/students/student-10.jpg",
      issueRemarks: "Book Issued",
      
    },
  ];